/*
 * Copyright (c) 2019
 *    Reliant Business Valuation, LLC - http://reliantvalue.com
 *    Author: Kirill Vizniuk - kirill@internalvaluation.com
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

import { ExportHistory } from "./export.history";

export class AppFileData {
  id: string; // File ID on Chrome LocalStorage
  data: string; // File Data in String
  name: string; // File Name
  path: string; // Full File Path on user FS
  size: number; // File Size
  history: ExportHistory;

  static parse(json: any): AppFileData {
    if(json){
      let a = new AppFileData();

      a.id   = json.id;
      a.data = json.data;
      a.name = json.name;
      a.path = json.path;
      a.size = Number(json.size);

      if(json.history){
        a.history = new ExportHistory(json.history);
      }


      return a;
    }else return null;
  }
}
